import { render, staticRenderFns } from "./AppJoinWaitlistForm.vue?vue&type=template&id=53e3a582&scoped=true&"
import script from "./AppJoinWaitlistForm.vue?vue&type=script&lang=js&"
export * from "./AppJoinWaitlistForm.vue?vue&type=script&lang=js&"
import style0 from "./AppJoinWaitlistForm.vue?vue&type=style&index=0&id=53e3a582&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3a582",
  null
  
)

export default component.exports